import { FormDataType } from "DataTypes/Form";

export const CaseCreationFormArr: FormDataType[] = [
  {
    id: "orderType",
    label: "Order Type",
    placeholder: "Select Order Type",
    boxType: "single-select-drop",
    boxSize: 12,
    validatetype: "dropdown",
    required: true,
    dropArr: [],
  },
  {
    id: "caseType",
    label: "Case Type",
    placeholder: "Select Case Type",
    boxType: "single-select-drop",
    boxSize: 12,
    validatetype: "dropdown",
    required: true,
    dropArr: [],
  },
  // {
  //   id: "description",
  //   label: "Description",
  //   placeholder: "Enter Description",
  //   boxType: "input-box",
  //   type: "text",
  //   boxSize: 12,
  //   validatetype: "acceptAll",
  //   required: true,
  //   multiline: true,
  //   multilineRows: 4,
  // },
];
